<!-- Popover thông báo — Carot ERP v2 (module-rail.jsx :: AppTopbar, notification-center.jsx).
     Neo dưới chuông, rộng 360, bo 10, bóng popover. Dữ liệu từ NotificationService SẴN CÓ
     (SSE, rơi về polling) — không dữ liệu mẫu. Hồng chỉ cho số đếm "N mới" và chấm chưa đọc.
     Bản cũ là ngăn kéo toàn chiều cao 400px với thanh ưu tiên 1 cạnh trái — đã gỡ. -->
@if (isOpen) {
  <!-- Lớp bắt click ngoài: một NÚT trong suốt (không phải div có click) để bàn phím/trình
       đọc màn hình cũng đóng được, và không cần bỏ qua luật a11y. -->
  <button
    type="button"
    class="notif-scrim fixed inset-0 z-40 cursor-default"
    tabindex="-1"
    [attr.aria-label]="'Button.Close' | translate"
    (click)="close()"
  ></button>

  <div
    class="notif-popover absolute right-0 top-full mt-2 z-50 w-notification-popover max-w-screen bg-warm-card border border-warm-border rounded-lg shadow-popover overflow-hidden flex flex-col"
    role="region"
    [attr.aria-label]="'Notification.Title' | translate"
    (keydown.escape)="close()"
  >
    <!-- Đầu: tiêu đề + "N mới" + đánh dấu đã đọc -->
    <div class="flex items-center gap-2 px-4 py-3 border-b border-warm-border">
      <h2 class="m-0 text-token-base font-bold text-warm-text">
        {{ 'Notification.Title' | translate }}
      </h2>
      @if (unreadCount > 0) {
        <span
          class="notif-new-count inline-flex items-center px-1.5 rounded-full bg-cta text-white text-token-label font-bold leading-4"
        >
          {{ 'Notification.NewCount' | translate: { count: unreadCount } }}
        </span>
      }
      <span class="flex-1"></span>
      @if (unreadCount > 0) {
        <button type="button" class="ds-link text-token-caption" (click)="onMarkAllRead()">
          {{ 'Notification.MarkAllRead' | translate }}
        </button>
      }
    </div>

    <!-- Lọc theo nhóm (giữ chức năng cũ của NotificationService.setCategory) -->
    <div class="flex items-center px-4 py-1.5 border-b border-warm-border-light">
      <button
        type="button"
        [dsMenuTriggerFor]="categoryMenu"
        class="h-control-xs inline-flex items-center gap-1 px-2 -ml-2 rounded-md text-token-caption font-medium text-warm-secondary hover:bg-warm-hover cursor-pointer focus-visible:outline-none focus-visible:shadow-focus"
      >
        <span class="material-symbols-outlined icon-size-token-xs" aria-hidden="true">
          filter_list
        </span>
        {{ getActiveCategoryName() }}
        <span class="material-symbols-outlined icon-size-token-xs" aria-hidden="true">
          expand_more
        </span>
      </button>
      <ds-menu #categoryMenu>
        <button type="button" ds-menu-item (click)="onCategoryChange(null)">
          <span class="material-symbols-outlined icon-size-token-xs mr-2" aria-hidden="true">
            apps
          </span>
          {{ 'Notification.Category.All' | translate }}
        </button>
        @for (cat of categories; track cat.value) {
          <button type="button" ds-menu-item (click)="onCategoryChange(cat.value)">
            <span class="material-symbols-outlined icon-size-token-xs mr-2" aria-hidden="true">
              {{ cat.icon }}
            </span>
            {{ cat.translateKey | translate }}
          </button>
        }
      </ds-menu>
    </div>

    <!-- Danh sách — cuộn trong 380px -->
    <div class="notif-list overflow-y-auto" role="list">
      @for (item of filteredNotifications; track item.id; let last = $last) {
        <div
          role="listitem"
          class="notif-row group relative flex gap-3 px-4 py-3 cursor-pointer transition-colors hover:bg-warm-hover"
          [class.border-b]="!last"
          [class.border-warm-border-light]="!last"
          [class.bg-soft]="!item.isRead"
          tabindex="0"
          (click)="onNotificationClick(item)"
          (keydown.enter)="onNotificationClick(item)"
        >
          <span
            class="shrink-0 w-8 h-8 rounded-full flex items-center justify-center"
            [class]="toneClass(item.priority)"
          >
            <span class="material-symbols-outlined icon-size-token-xs" aria-hidden="true">
              {{ getCategoryIcon(item.category) }}
            </span>
          </span>

          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-1.5">
              <p class="m-0 flex-1 min-w-0 truncate text-token-body font-semibold text-warm-text">
                {{ item.title }}
              </p>
              @if (!item.isRead) {
                <span class="notif-unread-dot shrink-0 w-2 h-2 rounded-full bg-cta"></span>
              }
            </div>
            <p class="m-0 mt-0.5 text-token-body-dense text-warm-hint line-clamp-2">
              {{ item.body }}
            </p>
            <p class="m-0 mt-1 text-token-caption text-warm-hint">
              {{ getTimeAgo(item.createdDate) }}
              @if (item.categoryName) {
                <span aria-hidden="true">·</span>
                {{ item.categoryName }}
              }
            </p>
          </div>

          <!-- Hành động khi rê chuột / focus: bỏ qua · tạm hoãn -->
          <div
            class="shrink-0 flex flex-col gap-0.5 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity"
          >
            <button
              type="button"
              class="w-6 h-6 flex items-center justify-center rounded-md text-warm-hint hover:bg-warm-card hover:text-warm-text cursor-pointer focus-visible:outline-none focus-visible:shadow-focus"
              [attr.aria-label]="'Notification.Dismiss' | translate"
              [dsTooltip]="'Notification.Dismiss' | translate"
              (click)="onDismiss($event, item.id)"
            >
              <span class="material-symbols-outlined icon-size-token-xs" aria-hidden="true">
                close
              </span>
            </button>
            <button
              type="button"
              [dsMenuTriggerFor]="snoozeMenu"
              class="w-6 h-6 flex items-center justify-center rounded-md text-warm-hint hover:bg-warm-card hover:text-warm-text cursor-pointer focus-visible:outline-none focus-visible:shadow-focus"
              [attr.aria-label]="'Notification.Snooze' | translate"
              [dsTooltip]="'Notification.Snooze' | translate"
              (click)="$event.stopPropagation()"
            >
              <span class="material-symbols-outlined icon-size-token-xs" aria-hidden="true">
                snooze
              </span>
            </button>
            <ds-menu #snoozeMenu>
              @for (opt of snoozeOptions; track opt.minutes) {
                <button type="button" ds-menu-item (click)="onSnooze($event, item.id, opt.minutes)">
                  {{ opt.label | translate }}
                </button>
              }
            </ds-menu>
          </div>
        </div>
      }

      @if (filteredNotifications.length === 0) {
        <div class="flex flex-col items-center justify-center gap-1 px-6 py-10 text-center">
          <span
            class="material-symbols-outlined icon-size-token-lg text-warm-hint"
            aria-hidden="true"
          >
            notifications
          </span>
          <p class="m-0 text-token-body font-semibold text-warm-text">
            {{ 'Notification.Center.EmptyTitle' | translate }}
          </p>
          <p class="m-0 text-token-caption text-warm-hint">
            {{ 'Notification.Center.EmptyHint' | translate }}
          </p>
        </div>
      }
    </div>

    <!-- Chân: xem tất cả -->
    <div class="px-4 py-2.5 border-t border-warm-border text-center">
      <button type="button" class="ds-link text-token-body-dense font-medium" (click)="onViewAll()">
        {{ 'Notification.ViewAll' | translate }}
      </button>
    </div>
  </div>
}
